import BuyAcessTable from './BuyAcessTable.component';

export default BuyAcessTable;